import dayjs from "dayjs";

const dateFormat = "YYYYMMDD";

const dateSlashFormat = "YYYY/MM/DD";

const yearMonthFormat = "YYYYMM";

/**
 * 現在日付を取得
 *
 * @returns
 */
export const date = () => dayjs().format(dateFormat);

/**
 * 現在日付の年月を取得
 *
 * @returns
 */
export const yearMonth = () => dayjs().format(yearMonthFormat);

/**
 * 指定日の文字列を取得
 *
 * @param date
 * @returns
 */
export const dateAt = (date: Date | string) => {
  return dayjs(date).format(dateFormat);
};

/**
 * 指定日の文字列を取得
 *
 * @param date
 * @returns
 */
export const dateWithSlashAt = (date: Date | string | undefined) => {
  return dayjs(date).format(dateSlashFormat);
};

/**
 * 指定日の初日を取得
 *
 * @param date
 * @returns
 */
export const startOfMonth = (date: string) => {
  return dayjs(date).startOf("month").format(dateFormat);
};

/**
 * 現在日付の年月を取得
 *
 * @returns
 */
export const yearMonthAt = (date: Date | string | undefined) => {
  return dayjs(date).format(yearMonthFormat);
};

/**
 * 日付チェック
 *
 * @param date
 * @returns
 */
export const validDate = (date: Date | string) => {
  if (!dayjs(date, dateFormat).isValid()) {
    return false;
  }
  if (typeof date === "string" && date !== "") {
    return (
      dayjs(date, dateFormat).format(dateFormat) === date.replaceAll("/", "")
    );
  }
  return true;
};

/**
 * 指定日の最終日を取得
 *
 * @param date
 * @returns
 */
export const endOfMonth = (date: string) => {
  return dayjs(date).endOf("month").format(dateFormat);
};

/**
 * 指定日に加算
 *
 * @param date 指定日
 * @param addDay 加算日数
 * @returns
 */
export const addDay = (date: string, addDay: string | number) => {
  if (typeof addDay === "number") {
    return dayjs(date).add(addDay, "day").format(dateFormat);
  } else {
    return dayjs(date).add(Number(addDay), "day").format(dateFormat);
  }
};
